<template>
  <router-view />
</template>

<script setup lang="ts">
  import { ResolvableTitleTemplate, useHead } from "@unhead/vue";
  import { useEnv } from "@/shared/composables/useEnv.ts";
  import { useInstitution } from "@/shared/stores/institution.ts";
  import { storeToRefs } from "pinia";
  import { computed } from "vue";

  const env = useEnv();

  const institutionStore = useInstitution();

  const { currentInstitution } = storeToRefs(institutionStore);

  useHead({
    titleTemplate: computed(() => {
      const acronym = currentInstitution.value?.acronym;
      const suffix = acronym ? acronym : env.VITE_APP_TITLE;
      return (title?: string) => (title ? `${title} | ${suffix}` : suffix);
    }) as unknown as ResolvableTitleTemplate,
  });
</script>
